import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/grades', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/grades', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/grades/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/grades/${data.grade_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/grades/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMainProgram = (Option = {}) => {
  return httpClient
    .get(
      '/api/main-programs?fields[academic_program_mains]=acp_id,acp_name_foreign&page=-1'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubProgram = (acp_id, Option = {}) => {
  return httpClient
    .get(
      `/api/sub-programs?fields[academic_program_subs]=acp_id,acps_id,acps_name_foreign,number_of_term_per_grade&filter[acp_id]=${acp_id}&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getLevel = (acps_id, Option = {}) => {
  return httpClient
    .get(
      `/api/levels?fields[academic_program_levels]=acps_id,level_id,level_name_foreign&filter[acps_id]=${acps_id}&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubject = (params, Option = {}) => {
  return httpClient
    .get(
      `/api/subject-cores?fields[academic_subjects]=subject_id,subject_name_foreign,subject_code,is_elective_subject_parent&fields[children]=subject_id,subject_name_foreign,subject_code,is_elective_subject_parent,parent_subject_id&include=children&filter[acps_id]=${params.acps_id}&filter[acp_id]=${params.acp_id}&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getGrade = (acps_id, Option = {}) => {
  return httpClient
    .get(
      `/api/grades?fields[academic_program_level_grades]=grade_id,grade_name_foreign,next_grade_id&filter[by_main_program]=${acps_id}&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const nextGrade = data => {
  return httpClient
    .post('/api/define-next-grades', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getAcademicCorePrograms = (Option = {}) => {
  return httpClient
    .get('/api/grades/academic-core-programs')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getIgnoreCycle = Options => {
  return httpClient
    .get('/api/grades/ignore-cycle', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getMainProgram,
  getSubProgram,
  getLevel,
  getSubject,
  getGrade,
  nextGrade,
  getAcademicCorePrograms,
  getIgnoreCycle
}
